import React, { useCallback, useEffect, useMemo, useState } from "react";
// import {
//   formatRuleSetToSentence,
//   processProductArrayDynamically,
// } from "../../../../../utils/helper";
import { useSelector } from "react-redux"; // Import useDispatch and useSelector from react-redux
// import EditIcon from "../../../../../components/CustomIcons/edit";
// import DeleteIcon from "../../../../../components/CustomIcons/delete";
import { formatRuleSetToSentence, processProductArrayDynamically } from "./data";
import EditIcon from "../../common/customIcons/edit";
import DeleteIcon from "../../common/customIcons/delete";
import Tooltip from "@mui/material/Tooltip";
import { Box, Typography, IconButton, Stack, Chip } from "@mui/material";

/**
 * Component to display formatted text based on a given rule set.
 *
 * @param {Object} props - Component props.
 * @param {Array} props.ruleSet - The rule set to be formatted.
 */
function PromotionRuleFormattedText({
  ruleSet,
  allCategories,
  userGroups,
  setShow = () => {},
  deleteHandler = () => {},
  isActionsAllow = false,
  showTooltip = false,
  className = "hstack flex-column flex-md-row gap-3",
}) {
  // Selectors to get categories and user groups from the state
  // const { isLoading: isLoadingCategory } = useSelector((state) => state.categories);
  // const {  , isLoading: isLoadingGroups } = useSelector((state) => state.products);

  // State to hold the formatted text parts and bold parts
  const isLoadingGroups = false;
  const isLoadingCategory = false;

  const [ruleFormatedText, setRuleFormattedText] = useState({
    textParts: [],
    boldParts: [],
  });
  // useDispatch hook to dispatch actions
  // useCallback to memoize the function to get a category by its ID
  const getCategoryById = useCallback(
    (categoryId) => allCategories?.find((item) => item.id === categoryId),
    [allCategories]
  );
  // useCallback to memoize the function to get a user group by its ID
  const getGroupById = useCallback(
    (groupId) => userGroups.find((item) => item.id === groupId),
    [userGroups]
  );
  // Effect to format the rule set to text when categories and user groups are loaded
  useEffect(() => {
    if (!isLoadingCategory && !isLoadingGroups) {
      const formatText = formatRuleSetToSentence({
        ruleSet,
        getCategoryById,
        getGroupById,
      });
      setRuleFormattedText(formatText);
    }
  }, [
    isLoadingCategory,
    isLoadingGroups,
    getCategoryById,
    getGroupById,
    userGroups,
    allCategories,
    ruleSet,
  ]);
  // Destructure the formatted text parts and bold parts from the state
  const { textParts = [], boldParts = [] } = ruleFormatedText;
  const getFormattedText = useMemo(() => {
    return textParts
      .map((part, index) => `${part} ${boldParts[index] && boldParts[index]}`)
      ?.join("");
  }, [textParts]);
  return (
    <Box
      className={className}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Tooltip title={showTooltip ? getFormattedText : ""} placement="top">
        <Typography
          component="p"
          sx={{
            mb: 0,
            color: "text.secondary",
            flexGrow: 1,
            pr: { md: 2 },
            wordBreak: "break-word",
          }}
        >
          {textParts?.map((part, index) => {
            const formattedTextObject = processProductArrayDynamically(boldParts[index]);
            return (
              <React.Fragment key={index}>
                {part?.trim() === "Then" && "\u00A0"}
                {boldParts[index] === "any_product" ? "Any Product" : part}
                {boldParts[index] !== "any_product" && boldParts[index] && (
                  <>
                    <Typography component="span" fontWeight="bold">
                      {formattedTextObject.formattedString}{" "}
                    </Typography>
                    {formattedTextObject.splitArray.length > 2 && (
                      <Tooltip title={formattedTextObject.splitArray.join(", ")} placement="top">
                        <Chip
                          label={`+${formattedTextObject.splitArray.length - 2}`}
                          size="small"
                          sx={{
                            minWidth: "1.5rem",
                            minHeight: "1.5rem",
                            border: "2px solid black",
                            borderRadius: "50px",
                            fontSize: "10px",
                            cursor: "pointer",
                            display: "inline-flex",
                            verticalAlign: "middle",
                            ml: 0.5,
                          }}
                        />
                      </Tooltip>
                    )}{" "}
                  </>
                )}
              </React.Fragment>
            );
          })}
        </Typography>
      </Tooltip>

      {isActionsAllow && (
        <Stack direction="row" spacing={1}>
          <Tooltip title="Edit" placement="top">
            <IconButton color="primary" onClick={() => setShow(true)}>
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete" placement="top">
            <IconButton color="error" onClick={() => deleteHandler()}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </Stack>
      )}
    </Box>
  );
}
export default PromotionRuleFormattedText;